import { BorderColors } from "@abel-technologies-as/components";
import styled from "styled-components";

const TopHeaderContainer = styled.div<{ showBorder: boolean }>`
	padding-bottom: 8px;
	border-bottom: ${({ showBorder }) => (showBorder ? `1px solid ${BorderColors.Secondary}` : "none")};
`;

const RenderElementContainer = styled.div`
	width: max-content;
`;

export { TopHeaderContainer, RenderElementContainer };
